import { INominationsResponce, NominationsT } from '../../../model/types';

interface IGetCurrentNominationLabel {
  $pollItems: INominationsResponce[];
  $currentNominationName: NominationsT | null;
}

export const getCurrentNominationLabel = (
  { $pollItems, $currentNominationName }: IGetCurrentNominationLabel
): string => $pollItems.find(item => item.name === $currentNominationName)?.label ?? '';
